import React, { createContext, Dispatch, useContext, useReducer } from "react";
import { RecentActivities, RecentInsights } from "./WasteManagementContext";
import {
  BinOverviewReportCard,
  GetDetectionChartData,
  GetInfraDetectionTrendData,
  InfraReportData,
  ProcessedDetectionChartData,
} from "../Models/Models";
import {
  InfraChartData,
  InfraGraphData,
  TotalDeviceCount,
} from "../Models/Models";
import { SnapViewInfo } from "../Models/Models";

export interface InfrastructureType {
  hasChartData: boolean;
  totalWasteMoniterValue: number;
  totalWasteValueChanges: string;
  totalWasteValueColor: string;
  averageFillWastelabel: number;
  avgWasteValueChanges: string;
  avgWasteValueColor: string;
  pageNo: number;
  pageSize: number;
  infraReportData: InfraReportData[];
  totalElements: number;
  groupId: string;
  type: string;
  siteCode: string;
  infraGraphData: InfraGraphData[];
  infraGraphDuration: string;
  infraChartData: InfraChartData[];
  GetInfraDetectionTrendData: GetInfraDetectionTrendData[];
  infraChartDuration: string;
  tooltipChange: number;
  tooltipValue: number;
  infrachartStartIndex: number;
  TotalDeviceCount: TotalDeviceCount[];
  GetDetectionChartData: GetDetectionChartData[];
  ProcessedDetectionChartData: ProcessedDetectionChartData[];
  snapViewInfo: SnapViewInfo[];
  fromDate: string;
  dates: string[];
  isSnapViewModalOpen: boolean;
  isImageViewModalOpen: boolean;
  selectedImage: string | null;
  showAll:boolean;
  currentDateIndex: number;
  infraDetectionDuration: string;
  loader: boolean;
  
}

const initialState: InfrastructureType = {
  hasChartData: false,
  totalWasteMoniterValue: 0,
  totalWasteValueChanges: "",
  totalWasteValueColor: "",
  averageFillWastelabel: 0,
  avgWasteValueChanges: "",
  avgWasteValueColor: "",
  pageNo: 0,
  pageSize: 10,
  infraReportData: [] as InfraReportData[],
  totalElements: 0,
  groupId: "",
  type: "",
  siteCode: "",
  infraGraphData: [] as InfraGraphData[],
  infraGraphDuration: "Last 6 months",
  infraChartData: [] as InfraChartData[],
  GetInfraDetectionTrendData: [] as GetInfraDetectionTrendData[],
  infraChartDuration: "months",
  infraDetectionDuration: "Monthly",
  tooltipChange: 0,
  tooltipValue: 0,
  infrachartStartIndex: 0,
  TotalDeviceCount: [] as TotalDeviceCount[],
  GetDetectionChartData: [] as GetDetectionChartData[],
  ProcessedDetectionChartData: [] as ProcessedDetectionChartData[],
  snapViewInfo: [],
  fromDate: "",
  dates: [],
  isSnapViewModalOpen: false,
  isImageViewModalOpen:false,
  selectedImage:null,
  showAll:false,
  currentDateIndex: 0,
  loader: false,
 
};

type ActionType =
  | {
      field: keyof InfrastructureType;
      type: "SET_FIELD";
      value:
        | string
        | string[]
        | boolean
        | number
        | HTMLElement
        | RecentActivities[]
        | RecentInsights[]
        | BinOverviewReportCard[]
        | InfraGraphData[]
        | InfraChartData[]
        | GetInfraDetectionTrendData[]
        | GetDetectionChartData[]
        | TotalDeviceCount[]
        | ProcessedDetectionChartData[]
        | SnapViewInfo[]
        | undefined
        | null;
    }
  | {
      type: "BULK_UPDATE";
      value: Partial<InfrastructureType>;
    }
  | {
      type: "RESET";
    }
  | {
      type: "SET_HAS_CHART_DATA";
      value: boolean;
    };

const reducer = (
  state: InfrastructureType,
  action: ActionType
): InfrastructureType => {
  switch (action.type) {
    case "SET_FIELD":
      return { ...state, [action.field]: action.value };
    case "BULK_UPDATE":
      return { ...state, ...action.value };
    case "RESET":
      return { ...initialState };
    default:
      return state;
  }
};

const InfrastructureProvider = createContext<{
  infrastructureState: InfrastructureType;
  dispatchInfrastructure: Dispatch<ActionType>;
}>({
  infrastructureState: initialState,
  dispatchInfrastructure: () => null,
});

type ContextProviderProps = {
  children: React.ReactNode;
};

const InfrastructureContext = ({ children }: ContextProviderProps) => {
  const [infrastructureState, dispatchInfrastructure] = useReducer(
    reducer,
    initialState
  );

  return (
    <InfrastructureProvider.Provider
      value={{ infrastructureState, dispatchInfrastructure }}
    >
      {children}
    </InfrastructureProvider.Provider>
  );
};

const useInfrastructure = () => {
  return useContext(InfrastructureProvider);
};

export { InfrastructureContext, useInfrastructure };
